import { segment } from '@actions/analytics';
import { emptyObject } from '@constants/empty';
import useTopology from '@api/hooks/topology/useTopology';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import { getPlusSubscriptionInfoLatest } from '@api/selectors/subscription';

const usePracticeSegmentAnalytics = (goalUID = '') => {
  const { topology: goalData } = useTopology(goalUID);

  const {
    subscription = emptyObject,
    expired_at,
    time_remaining
  } = useMyInfo(getPlusSubscriptionInfoLatest(goalUID)) || emptyObject;

  return (actionKey, additionalProps = emptyObject) => {
    segment.track(actionKey, {
      goal_name: goalData.name,
      goal_uid: goalData.uid,
      subscription_end_date: expired_at,
      subscription_duration: subscription.duration,
      is_subscription_active: time_remaining > 0,
      ...additionalProps
    });
  };
};

export default usePracticeSegmentAnalytics;
